import React from 'react';
import { DATE_FORMAT } from '../../../../../config/locale';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import {
  maintenanceChecklistDefaultProps,
  maintenanceChecklistPropTypes,
} from '../proptypes/MaintenanceChecklistPropTypes';

const MaintenanceChecklistBasicInformation = ({
  registeredBus,
  deadLine,
  driver,
}) => (
  <>
    {registeredBus !== null && (
      <ResourceProperty label="Bus:">
        {registeredBus ? registeredBus.companyBusId : '-'}
      </ResourceProperty>
    )}

    <ResourceProperty label="Fecha Límite:">
      {deadLine
        ? tzNormalizeDate({ date: deadLine, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>

    {driver !== null && (
      <>
        <ResourceProperty label="Conductor:">
          {driver ? driver.driverName : '-'}
        </ResourceProperty>

        <ResourceProperty label="Numero de Documento:">
          {driver ? driver.driverIdDocumentNumber : '-'}
        </ResourceProperty>
      </>
    )}
  </>
);

MaintenanceChecklistBasicInformation.propTypes = maintenanceChecklistPropTypes;

MaintenanceChecklistBasicInformation.defaultProps =
  maintenanceChecklistDefaultProps;

export default MaintenanceChecklistBasicInformation;
